<template>
  <div class="travelagencyhome">
    <!-- 返回导航栏 -->
    <div class="travelagencyhome-box">
      <!-- 公告 -->
      <div class="announce-box" v-if="annoList.length > 0">
        <p class="title">公告：</p>
        <div class="swiper-box"
             v-if="annoList.length > 0">
          <annoswiper :heightPx="'20'"
                      :dataList="annoList"
                      :isBorderStyle=true></annoswiper>
        </div>
      </div>
      <!-- 待办 -->
      <div v-if="dealNumber > 0" class="pending-box" @click="$router.push('/travelAgency/pendingList')">
        <div class="title-box">
          <img class="icon" src="../../assets/travelAgency/icon_tips_orange.png" alt="">
          <p class="title">待办提醒</p>
        </div>
        <div class="content-box">
          <div class="text-box">
            <p class="text">您当前共有{{ dealType }}等</p>
            <p class="count">{{ dealNumber }}</p>
            <p class="text">条待办等待处理</p>
          </div>
          <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
        </div>
      </div>
      <!-- 区域选择 -->
      <div class="area-header-box">
        <van-popover v-model="showRolePop"  theme="dark" placement="bottom-start">
          <div class="role-pop-box">
            <p class="title">您当前属于执法角色，可通过切换地址，查看全省旅行社情况。</p>
            <div class="close-btn" @click="showRolePop = false">我知道了</div>
          </div>
          <template #reference>
            <div class="areachoose-box" @click=" canFilterCity ? showCityPicker = true : ''">
              <p class="area-text">{{cityContent || ''}}</p>
              <img src="../../assets/travelAgency/ic_jiantou_down.png"
                    alt
                    class="down-icon"
                    v-if="canFilterCity" />
            </div>
          </template>
        </van-popover>
      </div>
      <!-- 营业状态/注册情况 -->
      <div class="area-state-box">
        <div class="tab-bar">
          <div :class="selectedTab==0? 'tab-item selected' : 'tab-item'" @click="selectedTab = 0">
            <p>营业状态</p>
          </div>
          <div :class="selectedTab==1? 'tab-item selected' : 'tab-item'" @click="selectedTab = 1">
            <p>注册情况</p>
          </div>
        </div>
        <div class="content-box">
          <div class="title-box">
            <p class="title">全{{ cityContent }}旅行社</p>
          </div>
          <div class="count-box" @click="onTapAllAgency">
            <p class="count">{{allCount}}</p>
            <p class="unit">家</p>
            <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
          </div>
          <!-- 营业状态 -->
          <div v-if="selectedTab == 0" class="bussiness-box">
            <div class="status-box">
              <!-- 正常 -->
              <div class="status-item-box" @click="onTapTravelStatusAgency(1)">
                <div class="status">
                  <div class="indicator normal"></div>
                  <p class="title">正常</p>
                </div>
                <div class="count-box">
                  <p class="count">{{ normal }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
              <!-- 撤销 -->
              <div class="status-item-box" @click="onTapTravelStatusAgency(4)">
                <div class="status">
                  <div class="indicator cancel"></div>
                  <p class="title">撤销</p>
                </div>
                <div class="count-box">
                  <p class="count">{{ annul }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
              <!-- 吊销 -->
              <div class="status-item-box" @click="onTapTravelStatusAgency(2)">
                <div class="status">
                  <div class="indicator revoke"></div>
                  <p class="title">吊销</p>
                </div>
                <div class="count-box">
                  <p class="count">{{ revocation }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
              <!-- 注销 -->
              <div class="status-item-box" @click="onTapTravelStatusAgency(3)">
                <div class="status">
                  <div class="indicator logout"></div>
                  <p class="title">注销</p>
                </div>
                <div class="count-box">
                  <p class="count">{{ writeOff }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
            </div>
            <div class="separator"></div>
            <!-- 监管 -->
            <div class="supervision-box">
              <p class="title">监管情况</p>
              <!-- 重点关注 -->
              <div class="supervision-item" @click="onTapSuperviseAgency('supervise')">
                <p class="item-title">重点关注</p>
                <div class="count-box">
                  <p class="count">{{ allSuperviseCount }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
              <!-- 黑名单监管 -->
              <div class="supervision-item" @click="onTapSuperviseAgency('blacklist')">
                <p class="item-title">黑名单监管</p>
                <div class="count-box">
                  <p class="count">{{ allBlackCount }}</p>
                  <p class="unit">家</p>
                  <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
                </div>
              </div>
            </div>
          </div>
          <!-- 注册情况 -->
          <div v-else class="register-box">
            <div class="separator"></div>
            <!-- 已注册统计 -->
            <div class="register-count-box" @click="onTapRegisterAgency(true)">
              <p class="title">一机管平台注册 </p>
              <div class="count-box">
                <p class="count">{{ auditing + passed }}</p>
                <p class="unit">家</p>
                <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
              </div>
            </div>
            <!-- 待审核 -->
            <div class="register-item" @click="onTapReviewStateAgency(1)">
              <div class="wait-box">
                <p class="item-title">待审核</p>
                <van-popover
                  v-model="showWaitPop"
                  theme="dark"
                  trigger="click"
                  placement="bottom-start"
                >
                  <p class="tips-text">审核工作由相关文旅部门进行</p>
                  <template #reference>
                    <div class="icon-box">
                      <img @click.stop="showWaitPop = true" src="../../assets/travelAgency/icon_Tips.png" class="icon-tip">
                    </div>
                  </template>
                </van-popover>
              </div>
              <div class="count-box">
                <p class="count">{{ auditing }}</p>
                <p class="unit">家</p>
                <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
              </div>
            </div>
            <!-- 审核通过 -->
            <div class="register-item" @click="onTapReviewStateAgency(3)">
              <p class="item-title">审核通过</p>
              <div class="count-box">
                <p class="count">{{ passed }}</p>
                <p class="unit">家</p>
                <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
              </div>
            </div>
            <!-- 未注册统计 -->
            <div class="register-count-box" @click="onTapRegisterAgency(false)">
              <p class="title">尚未注册 </p>
              <div class="count-box">
                <p class="count">{{ notRegister }}</p>
                <p class="unit">家</p>
                <img src="../../assets/travelAgency/ic_righticon.png" class="icon">
              </div>
            </div>
          </div>        
        </div>
      </div>
      <!-- 通知栏1 -->
      <!-- <div class="notice-box"
           @click="$router.push('/travelAgency/todoList?cityid='+ originCityId)"
           v-if="originCityId != '34' && dealNumber > 0">
        <div class="left-block"></div>
        <div class="center-text">有<span class="greencolor">{{dealNumber}}</span>条旅行社信息待审核
        </div>
        <div class="right-box">
          <p class="texts">去审核</p>
          <img src="../../assets/travelAgency/ic_righticon.png"
               alt
               class="right-icon" />
        </div>
      </div> -->
      <!-- 通知栏2 -->
      <!-- <div class="notice-box1"
           v-if="annoList.length > 0">
        <div class="left-text">公告</div>
        <div class="vline">
          <div class="borders-1px"></div>
        </div>
        <div class="swiper-box"
             v-if="annoList.length > 0">
          <annoswiper :heightPx="'20'"
                      :dataList="annoList"></annoswiper>
        </div>
      </div> -->
      <!-- 地区旅行社家数与评分 -->
      <!-- <div class="area-box">
        <div class="title-box">
          <div class="areachoose-box"
               @click=" (originCityId == '34') ? showCityPicker = true : ''">
            <p class="area-text">{{cityContent || ''}}</p>
            <img src="../../assets/travelAgency/ic_jiantou_down.png"
                 alt
                 class="down-icon"
                 v-if="originCityId == '34'" />
          </div>
          <img src="../../assets/travelAgency/ic_search.png"
               alt
               class="search-icon"
               @click="$router.push('/travelAgency/search')" />
        </div>
        <div class="content-box">
          <div :class="index == 0 ? 'items-box one-item' : 'items-box'"
               v-for="(lists,index) in areaTravellList"
               :key="index"
               @click="goTravelList(index)">
            <div class="name-box">
              <p class="names">{{lists.title}}</p>
              <img src="../../assets/travelAgency/ic_righticon.png"
                   alt
                   class="right-icon" />
            </div>
            <div class="numbers">{{lists.numbers}}</div>
            <div class="compare-box">
              <p class="compare-text">较上月</p>
              <p class="price-box"
                 v-if="index == 0">
                <span class="equal"
                      v-if="lists.compare == 'equal'">持平</span>
                <span v-if="lists.compare == 'add' || lists.compare == 'decrease'"
                      :class="lists.compare == 'add' ? 'price addprice' : 'price decreprice'">{{lists.compare == 'add' ? '+' : '-'}}</span>
                <span v-if="lists.compare == 'add' || lists.compare == 'decrease'"
                      :class="lists.compare == 'add' ? 'price addprice' : 'price decreprice'">{{lists.price}}</span>
                <img src="../../assets/travelAgency/ic_add.png"
                     alt=""
                     v-if="lists.compare == 'add'"
                     class="jiantou" />
                <img src="../../assets/travelAgency/ic_decre.png"
                     alt=""
                     v-if="lists.compare == 'decrease'"
                     class="jiantou" />
              </p>
              <p class="price-box"
                 v-else>
                <span class="equal"
                      v-if="lists.compare == 'equal'">持平</span>
                <span v-if="lists.compare == 'add' || lists.compare == 'decrease'"
                      :class="lists.compare == 'add' ? 'price decreprice' : 'price addprice'">{{lists.compare == 'add' ? '+' : '-'}}</span>
                <span v-if="lists.compare == 'add' || lists.compare == 'decrease'"
                      :class="lists.compare == 'add' ? 'price decreprice' : 'price addprice'">{{lists.price}}</span>
                <img src="../../assets/travelAgency/ic_decre.png"
                     alt=""
                     v-if="lists.compare == 'add'"
                     class="jiantou jiantou-transform" />
                <img src="../../assets/travelAgency/ic_add.png"
                     alt=""
                     v-if="lists.compare == 'decrease'"
                     class="jiantou jiantou-transform" />
              </p>
            </div>
            <div class="one-item-line"
                 v-if="index == 0">
              <rline></rline>
            </div>
          </div>
          <div class="vline">
            <div class="borders-1px"></div>
          </div>

        </div>

      </div> -->
      <!-- 月度趋势 -->
      <div class="cityranking-box monthlytrend-box">
        <div class="title-box">月度趋势</div>
        <div class="content-box">
          <div class="ranking-wrap">
            <tabmonth :tabList="rankingTab"
                      :ref="'monthRef'"
                      :name="'rankingTab2'"
                      @onSwitch="myPendingMonth"></tabmonth>
          </div>
          <!-- <div class="unit-box">单位（家）</div> -->
          <div style="height: 270px;">
            <lineCharts :interval="1"
                        :showYear="true"
                        :data="lineData"
                        :color="color"
                        :type="monthCurrent===2? '黑名单' : monthCurrent === 1? '重点关注' : ''"
                        :unit="'家'"
                        v-if="showLincharts"
                        :showNum="true" />
          </div>
        </div>
      </div>
      <!-- 州市排名 -->
      <div class="cityranking-box">
        <div class="title-box">州市排名</div>
        <div class="content-box">
          <div class="ranking-wrap">
            <tab :tabList="rankingTab"
                 :ref="'rankRef'"
                 :name="'rankingTab'"
                 @onSwitch="myPending"></tab>
          </div>
          <div class="city-contain-box">
            <rankCharts :rankList="rankLists"
                        :isAll="numberCurrent == 0 ? true : false" />
          </div>
          <div class="lookmore-box"
               @click="onShowMore"
               v-if="isShowMore">
            <span class="txts"
                  v-if="showMore">展开所有排名</span>
            <span class="txts"
                  v-else>收起所有排名</span>
            <span>
              <img src="../../assets/travelAgency/ic_down2.png"
                   alt=""
                   class="img-more"
                   v-if="showMore" />
              <img src="../../assets/travelAgency/ic_down2.png"
                   alt=""
                   class="img-more img-more-translate"
                   v-else />
            </span>

          </div>
        </div>
      </div>
    </div>
    <!-- 城市弹窗 -->
    <van-popup v-model="showCityPicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="cityColumns"
                  @cancel="showCityPicker = false"
                  @confirm="getCityValue"
                  value-key="content"
                  :default-index="cityIndex" />
    </van-popup>
  </div>
</template>
<script>
    import rankCharts from './components/RankCharts'
    import tab from 'comps/tab'
    import lineCharts from '../guideSystem/components/LineCharts'
    import api from '../../service/modules/travel'
    import apig from "../../service/modules/guide";
    import annoswiper from './components/anno-swiper'
    import rline from './components/line'

    export default {
        name: 'TravelAgencyHome',
        components: {
            rankCharts,
            'tab': tab,
            'tabmonth': tab,
            lineCharts,
            annoswiper,
            rline
        },

        data () {
            return {
                cityIndex: 0,
                showCityPicker: false,
                cityId: '',
                cityContent: '',
                showMore: true,
                cols1: 1,
                cityColumns: [],
                rankingTab: ['营业中总数', '重点关注', '黑名单'],
                areaTravellList: [
                    {
                        title: '营业中旅行社(家)',
                        numbers: '',
                        compare: '',
                        price: ''
                    }, {
                        title: '重点关注旅行社(家)',
                        numbers: '',
                        compare: '',
                        price: ''
                    }, {
                        title: '黑名单旅行社(家)',
                        numbers: '',
                        compare: '',
                        price: ''
                    }
                ],
                // 待审核旅行社数量
                auditing: 0,
                // 审核通过
                passed: 0,
                // 未注册
                notRegister: 0,
                // 全省旅行社
                allCount:0,
                // 旅行社状态
                // 正常
                normal: 0,
                // 撤销
                revocation: 0,
                // 吊销
                writeOff: 0,
                // 注销
                annul: 0,
                // 重点关注
                allSuperviseCount: 0,
                // 黑名单
                allBlackCount: 0,
                rankList: [],
                rankListInit: [],
                lineData: [], // 折线图
                color: 'green',
                rankLists: [],
                annoList: [],
                numberCurrent: 0,
                monthCurrent: 0,
                isShowMore: false,
                dealNumber: 0,
                dealType:'',
                isJurisdict: false, // 权限数据加载完毕,
                originCityId: '',
                showLincharts: false,
                selectedTab: 0,
                showWaitPop: false,
                showRolePop: false,
                travelRole: {
                  OrgInfo: {
                    orgRegionType: ''
                  },
                  roleName: ''
                },
                canFilterCity: false,

            };
        },

        computed: {},

        watch: {},

        methods: {
            // 获取用户角色
            getGuideContent(type = 'GUIDE') {
              // 获取用户权限
              apig.getUser(type).then(res => {
                if (res.ret === 0) {
                  if (res.data) {
                    this.travelRole = res.data;
                    console.log('>>>>>>> get user success = ', res.data)
                    if (this.travelRole.roleName.includes('enforceLawTravel')) {
                      // 执法角色 - 1.提示 2.能筛选区域
                      console.log('>>>>>>>>> has pop =',localStorage.hasPopRoleTip)
                      if (localStorage.hasPopRoleTips == null || localStorage.hasPopRoleTips == 0) {
                        // 没有弹出过提示才需要弹
                        this.showRolePop = true
                        localStorage.hasPopRoleTips = 1
                      }
                      this.canFilterCity = true
                    } else {
                      // 非执法角色 - 只有省级可以筛选区域
                      if (this.travelRole.OrgInfo.orgRegionId == '34') {
                        this.canFilterCity = true
                      }
                    }
                  }
                }
              });
            },
            // 拉取待办数量
            // 旅行社
            getNoticeNum () {
                this.$store.dispatch('notice/getTravelNum')
            },
            // 跳转列表页
            goTravelList (index) {
                localStorage.travelTabHomeCurrentIndex = parseInt(index)
                localStorage.travelCityId = this.cityId
                localStorage.travelCityContent = this.cityContent
                setTimeout(() => {
                    this.$router.push({ path: '/travelAgency/list', query: { cityId: this.cityId, cityText: this.cityContent, defaultState: 3 } })
                }, 300)
            },
            // 州市排行tag选择
            myPending (index) {
                this.numberCurrent = index
                this.isShowMore = false
                this.showMore = true
                if (this.isJurisdict) {
                    if (index === 0) {
                        this.getCityAllNumber()
                    }
                    if (index === 1) {
                        this.getKeySupervisionList()
                    }
                    if (index === 2) {
                        this.getCityBlackNumber()
                    }
                }
            },
            // 月度趋势tag选择
            myPendingMonth (index) {
                this.monthCurrent = index
                if (this.isJurisdict) {
                    if (index === 0) {
                        this.getAllMonthNumber()
                    }
                    if (index === 2) {
                        this.getBlackMonthNumber()
                    }
                    if (index === 1) {
                        this.getHomeMonthKeyList()
                    }
                }
            },
            // 城市选择
            getCityValue (value) {
                if (value.value === this.cityId) {
                    return false
                }
                this.cityId = value.value
                this.cityContent = value.content
                this.showCityPicker = false
                if (this.isJurisdict) {
                    this.getHomeTravelNumber()
                    this.$refs.monthRef.switchTab(0);
                    if (this.monthCurrent === 2) {
                        this.getBlackMonthNumber()
                    } else if (this.monthCurrent === 0) {
                        this.getAllMonthNumber()
                    } else {
                        this.getHomeMonthKeyList()
                    }
                    this.$refs.rankRef.switchTab(0);
                    if (this.numberCurrent === 0) {
                        this.getCityAllNumber()
                    } else if (this.numberCurrent === 1) {
                        this.getKeySupervisionList()
                    } else if (this.numberCurrent === 2) {
                        this.getCityBlackNumber()
                    }
                }
            },
            // 显示或隐藏更多
            onShowMore () {
                if (this.showMore) {
                    document.querySelector('.city-contain-box').style.maxHeight = '2000px'
                    this.showMore = false
                    this.rankLists = this.rankList
                } else {
                    document.querySelector('.city-contain-box').style.maxHeight = '200px'
                    this.showMore = true
                    this.rankLists = this.rankListInit
                }
            },
            // 获取所有的市
            getAllCity () {
                api.getCity({ city: 34 }).then(res => {
                    if (res.ret === 0) {
                        let city = []
                        city.push({
                            value: '',
                            content: '云南省'
                        })
                        this.cityColumns = [...city, ...res.data.list]
                        // 列表也返回旅行社首页保留上次的州市信息
                        if (localStorage.travelCityId) {
                            this.cityId = localStorage.travelCityId
                            this.cityContent = localStorage.travelCityContent
                            this.originCityId = localStorage.originCityId
                            this.isJurisdict = true
                            if (localStorage.originCityId != '34') {
                                // 只有州市才会加载未审核事项
                                this.getNotDealList()
                            }
                            this.getSnnoList()
                            this.getHomeTravelNumber()
                            this.getCityAllNumber()
                            this.getAllMonthNumber()
                            setTimeout(() => {
                                localStorage.removeItem('travelCityId')
                                localStorage.removeItem('travelCityContent')
                            }, 300)
                        } else {
                            this.getjurisdiction()
                        }
                    }
                });
            },
            // 州市排名(营业中总数)
            getCityAllNumber () {
                api.getCityAllNumber({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.onDealProvinceData(res.data)
                    }
                })
            },
            // 州市排名(黑名单)
            getCityBlackNumber () {
                api.getCityBlackNumber({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.onDealProvinceData(res.data)
                    }
                })
            },
            // 州市排名(重点监督)
            getKeySupervisionList () {
                api.getKeySupervisionList({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.onDealProvinceData(res.data)
                    }
                })
            },
            // 月度趋势（营业中总数）
            getAllMonthNumber () {
                api.getAllMonthNumber({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        this.onDealMonthData(res.data)
                    }
                })
            },
            // 月度趋势（重点监督）
            getHomeMonthKeyList () {
                api.getHomeMonthKeyList({ city: this.cityId || '34' }).then(res => {
                    if (res.ret === 0) {
                        this.onDealMonthData(res.data)
                    }
                })
            },
            // 月度趋势（黑名单）
            getBlackMonthNumber () {
                api.getBlackMonthNumber({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        this.onDealMonthData(res.data)
                    }
                })
            },
            // 旅行社家数（营业中、黑名单、重点监督）
            getHomeTravelNumber () {
                api.getHomeTravelNumber({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        let areaTravellList = this.areaTravellList
                        areaTravellList[0].numbers = res.data.allCount
                        areaTravellList[0].compare = res.data.allCount === res.data.previousMonthCount ? 'equal' : (res.data.allCount > res.data.previousMonthCount ? 'add' : 'decrease')
                        areaTravellList[0].price = res.data.allCount - res.data.previousMonthCount

                        areaTravellList[1].numbers = res.data.allSuperviseCount
                        areaTravellList[1].compare = res.data.allSuperviseCount === res.data.previousMonthSuperviseCount ? 'equal' : (res.data.allSuperviseCount > res.data.previousMonthSuperviseCount ? 'add' : 'decrease')
                        areaTravellList[1].price = res.data.allSuperviseCount - res.data.previousMonthSuperviseCount

                        areaTravellList[2].numbers = res.data.allBlackCount
                        areaTravellList[2].compare = res.data.allBlackCount === res.data.previousMonthBlackCount ? 'equal' : (res.data.allBlackCount > res.data.previousMonthBlackCount ? 'add' : 'decrease')
                        areaTravellList[2].price = res.data.allBlackCount - res.data.previousMonthBlackCount
                        this.areaTravellList = areaTravellList
                        this.auditing = res.data.auditing
                        this.passed = res.data.passed
                        this.allCount = res.data.allCount
                        this.notRegister = res.data.notRegister
                        this.normal = res.data.normal
                        this.revocation = res.data.revocation
                        this.writeOff = res.data.writeOff
                        this.annul = res.data.annul
                        this.allSuperviseCount = res.data.allSuperviseCount
                        this.allBlackCount = res.data.allBlackCount
                    }
                })
            },
            // 旅行社公告列表
            getSnnoList () {
                api.getSnnoList({ city: this.originCityId }).then(res => {
                    if (res.ret === 0) {
                        let annoList = []
                        let resData = JSON.parse(res.data)
                        // let colorArr = ['#FF4D4D','#FF8C19','#2283E6','#36B374']
                        if (resData && resData.length > 0 && resData !== '[]') {
                            resData.map((items, index) => {
                                let colorStrs = ''
                                switch (items.notice_type) {
                                case 'T01':
                                case 'T02':
                                case 'T07':
                                case 'T08':
                                case 'T09':
                                case 'T13':
                                case 'T19':
                                    colorStrs = '#FF8C19' // 橙色
                                    break;
                                case 'T03':
                                case 'T14':
                                case 'T15':
                                    colorStrs = '#2283E6' // 蓝色
                                    break;
                                case 'T04':
                                case 'T05':
                                case 'T17':
                                case 'T18':
                                case 'T20':
                                case 'T21':
                                case 'T22':
                                case 'T23':
                                case 'T24':
                                    colorStrs = '#36B374' // 绿色
                                    break;
                                case 'T06':
                                case 'T10':
                                case 'T11':
                                case 'T12':
                                    colorStrs = '#FF4D4D' // 红色
                                    break;
                                default:
                                    colorStrs = '#36B374' // 绿色
                                    break;
                                }
                                annoList.push({ tags: items.group_name, content: items.content.replace('travel', JSON.parse(items.value).travel).replace('orgName', JSON.parse(items.value).orgName).replace('name', JSON.parse(items.value).name), colorStr: colorStrs, url: items.url })
                            })
                            this.annoList = annoList
                            console.log('公告列表：', annoList)
                        }
                    }
                })
            },
            // 旅行社首页待办(州市才有)
            getNotDealList () {
                api.getNotDealList({}).then(res => {
                    if (res.ret === 0) {
                        this.dealNumber = res.data.count
                        if (res.data.type === 1) {
                          this.dealType = '“旅行社信息审核”'
                        } else if (res.data.type === 7) {
                          this.dealType = '“单项委托审批”'
                        }
                    }
                })
            },
            // 州市排名数据处理
            onDealProvinceData (val) {
                let rankList = []
                let rankListInit = []
                let resData = val.sort(function (a, b) { return parseInt(b.count) - parseInt(a.count); })
                // 州市权限地区置顶
                let curItem = {}
                let itemIndex = -1
                // 上季度排名
                let previousArr = []
                // 当前季度排名
                let currentArr = []
                resData.map((items, index) => {
                    items.cardNo = index + 1
                    items.isTop = 0
                    previousArr.push(items.previousCount)
                    currentArr.push(items.currentCount)
                    if (this.cityId && items.city_id === this.cityId) {
                      // 州市权限地区置顶
                        curItem.cardNo = items.cardNo
                        curItem.isTop = 1
                        curItem.cityName = items.cityName
                        curItem.cityShortName = items.cityShortName
                        curItem.city_id = items.city_id
                        curItem.count = items.count
                        curItem.previousCount = items.previousCount
                        curItem.currentCount = items.currentCount
                        // 记录州市权限地区置顶位置
                        itemIndex = index
                    }
                })
                previousArr.sort(function (a, b) { return parseInt(b) - parseInt(a); })
                currentArr.sort(function (a, b) { return parseInt(b) - parseInt(a); })
                if (itemIndex >= 0) {
                  // 新增了一条置顶数据，需要删除原位置数据
                  resData.splice(itemIndex, 1)
                }
                if (this.cityId && curItem.cardNo) {
                    resData.unshift(curItem)
                }
                for (var i = 0; i < resData.length; i++) {
                    var obj = {}
                    obj.id = i + 1
                    obj.city = resData[i].cityShortName
                    obj.mark = parseInt(resData[i].count)
                    let perviousScore = previousArr.indexOf(resData[i].previousCount)
                    let currentScore = currentArr.indexOf(resData[i].currentCount)
                    obj.status = currentScore === perviousScore ? 'equal' : (perviousScore > currentScore ? 'add' : 'decrease')
                    obj.number = Math.abs(perviousScore - currentScore)
                    obj.cardNo = resData[i].cardNo
                    obj.isTop = resData[i].isTop
                    rankList.push(obj)
                    if (i < 5) {
                        rankListInit.push(obj)
                    }
                }
                if (rankList.length > 6) {
                    this.isShowMore = true
                }
                this.rankListInit = rankListInit
                this.rankList = rankList
                this.rankLists = rankListInit
            },
            // 月度趋势数据格式处理
            onDealMonthData (val) {
                let monthList = []
                let resData = val.reverse()
                resData.map((items, index) => {
                    let obj = {}
                    obj.xAxis = items.date
                    obj.num = items.count
                    monthList.push(obj)
                })

                this.showLincharts = false
                this.lineData = monthList

                this.$nextTick(() => {
                    this.showLincharts = true
                })
                console.log(this.lineData)
            },
            // 地区权限
            getjurisdiction () {
                api.getjurisdiction({ city: null }).then(res => {
                    if (res.ret === 0) {
                        if (res.data.OrgInfo.orgRegionType === '1') {
                            // 省级
                            this.cityId = ''
                            this.cityContent = '云南省'
                            this.isJurisdict = true
                            this.originCityId = '34'
                        } else if (res.data.OrgInfo.orgRegionType === '2') {
                            // 州市级
                            console.log('this.cityColumns:', this.cityColumns)
                            this.cityColumns.map((items, index) => {
                                // this.cityColumns[0].map((items, index) => {
                                if (items.value === res.data.OrgInfo.orgRegionId) {
                                    this.cityId = res.data.OrgInfo.orgRegionId
                                    this.cityContent = items.content
                                    this.originCityId = res.data.OrgInfo.orgRegionId
                                }
                                console.log('this.originCityId:', this.originCityId)
                            })
                            this.isJurisdict = true
                            // 只有州市才会加载未审核事项
                            this.getNotDealList()
                        } else if (res.data.OrgInfo.orgRegionType === '3' && this.travelRole.roleName.includes('enforceLawTravel')) {
                          // 区县并且是执法角色 - 视为省级 也可以查看全省数据
                          this.cityId = ''
                          this.cityContent = '云南省'
                          this.isJurisdict = true
                          this.originCityId = '34'
                        }
                        localStorage.originCityId = this.originCityId
                        this.getSnnoList()
                        this.getHomeTravelNumber()
                        this.getCityAllNumber()
                        this.getAllMonthNumber()
                    }
                })
            },
            
            onTapAllAgency () {
              this.$router.push({ path: '/travelAgency/listNew', query: { cityId: this.cityId, cityName: this.cityContent } })
            },

            onTapReviewStateAgency (reviewState) {
              // 待审核/审核通过
              this.$router.push({ path: '/travelAgency/listNew', query: { cityId: this.cityId, cityName: this.cityContent, review: reviewState } })
            },
            onTapTravelStatusAgency (status) {
              // 正常/吊销/注销/撤销
              this.$router.push({ path: '/travelAgency/listNew', query: { cityId: this.cityId, cityName: this.cityContent, state: status } })
            },
            onTapSuperviseAgency (supervise) {
              // 重点监管/黑名单
              this.$router.push({ path: '/travelAgency/listNew', query: { cityId: this.cityId, cityName: this.cityContent, supervise:supervise } })
            },
            onTapRegisterAgency (register) {
              // 已注册/未注册
              this.$router.push({ path: '/travelAgency/listNew', query: { cityId: this.cityId, cityName: this.cityContent, register: register } })
            }

        },
        beforeRouteLeave(to, from, next) {
          const routerArr = ['/travelAgency/listNew'] //去这些界面我需要缓存
          if (!routerArr.includes(to.path)) {
          // 不在缓存列表中，从cachedViews缓存列表中移除
            this.$store.commit('refund/DEL_CACHED_VIEW', from)
          } else {
            this.$store.commit('refund/ADD_CACHED_VIEW', from)
          }
          next()
        },
        beforeMount() {
          this.getGuideContent()
        },
        mounted () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
            this.getNoticeNum()
            this.getAllCity()
            localStorage.travelNotice = setInterval(() => {
                this.getSnnoList()
            }, 60000)
        },
        created () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        },
        beforeDestroy () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        },
        destroyed () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        }
    }
</script>
<style scoped lang="less">
.travelagencyhome {
  width: 100%;
  // height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-bottom: 24px;

  .line-contain {
    height: 250px;
    box-sizing: border-box;
    padding: 0 12px;
    overflow: hidden;
    .echarts-contain {
      margin-top: -35px;
    }
  }
  .travelagencyhome-box {
    box-sizing: border-box;
    padding: 16px 12px 0 12px;
    .announce-box {
      display: flex;
      height: 40px;
      background-color: #fff8f1;
      align-items: center;
      padding-left: 14px;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #1e2226;
      }
      .swiper-box {
        width: 280px;
      }
    }
    .pending-box {
      margin-top: 10px;
      padding: 12px;
      background-color: white;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-bottom: 12px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      .title-box {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 5px;
          width: 18px;
          height: 18px;
        }
        .title {
          color: #1e2226;
          font-weight: 500;
          font-size: 14px;
        }
      }
      .content-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 8px;
        .text-box {
          display: flex;
          flex-direction: row;
          .text {
            color: #1e2226;
            font-size: 12px;
            font-weight: 400;
          }
          .count {
            padding-left: 2px;
            padding-right: 2px;
            color: #ef750a;
            font-size: 12px;
            font-weight: 400;
          }
        }
        .icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    .area-header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      box-sizing: border-box;
      padding-bottom: 12px;
      padding-top: 8px;

      .areachoose-box {
        display: flex;
        align-items: center;

        .area-text {
          font-size: 20px;
          font-family: PingFang SC, Arial, sans-serif;
          -webkit-font-smoothing: antialiased;
          font-weight: 700;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          margin-right: 4px;
        }
        .down-icon {
          width: 6px;
        }
      }
    }
    .area-state-box {
      background-color: white;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      padding-bottom: 24px;
      .tab-bar {
        display: flex;
        height: 44px;
        .tab-item {
          font-size: 14px;
          font-weight: 400;
          color: #71747a;
          background-color: #f7f8fa;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .selected {
          color: #36b374;
          font-weight: 500;
          background-color: white;
        }
      }
      .content-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
        .title-box {
          margin-bottom: 4px;
          .title {
            color: #1e2226;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .count-box {
          display: flex;
          align-items: end;
          .count {
            color: #1e2226;
            font-family:'DIN-Bold';
            font-size: 24px;
            font-weight: 700;
          }
          .unit {
            font-size: 12px;
            color: #9da0a4;
            padding-bottom: 2.5px;
            padding-left: 2px;
          }
          .icon {
            width: 12px;
            height: 12px;
            padding-bottom: 2px;
          }
        }
        .separator {
          width: 100%;
          height: 1px;
          background-color: #ecedf0;
        }
        .bussiness-box {
          width: 100%;
          padding-left: 20px;
          padding-right: 20px;
          .status-box {
            display: flex;
            justify-content: center;
            margin-top: 24px;
            margin-bottom: 20px;
            .status-item-box {
              display: flex;
              flex-direction: column;
              margin-right: 22px;
              .status {
                display: flex;
                align-items: center;
                margin-bottom: 4px;
                .title {
                  color: #1e2226;
                  font-size: 14px;
                }
                .indicator {
                  width: 3px;
                  height: 11px;
                  margin-right: 5px;
                }
                .normal {
                  background-color: #36b374;
                }
                .cancel {
                  background-color: #ef750a;
                }
                .revoke {
                  background-color: #fc523f;
                }
                .logout {
                  background-color: #1673d3;
                }
              }
              .count {
                font-size: 18px;
              }
              .unit {
                padding-bottom: 1.5px;
              }
              .icon {
                padding-bottom: 1px;
              }
            }
            .status-item-box:last-child {
              margin-right: 0;
            }
          }
          .supervision-box {
            margin-top: 18px;
            display: flex;
            flex-direction: column;
            .title {
              color: #1e2226;
              font-weight: 500;
              font-size: 14px;
              margin-bottom: 4px;
            }
            .supervision-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              background-color: #f5f7fa;
              height: 32px;
              padding-left: 10px;
              padding-right: 10px;
              margin-top: 8px;
              .item-title {
                color: #71747a;
                font-size: 14px;
              }
              .count {
                font-size: 16px;
              }
              .unit {
                padding-bottom: 1.5px;
              }
              .icon {
                padding-bottom: 1px;
              }
            }
          }
        }
        .register-box {
          width: 100%;
          padding-left: 20px;
          padding-right: 20px;
          display: flex;
          flex-direction: column;
          .separator {
            margin-top: 18px;
            margin-bottom: 18px;
          }
          .register-count-box {
            display: flex;
            margin-bottom: 4px;
            .title {
              color: #1e2226;
              font-size: 14px;
              font-weight: 500;
              margin-right: 6px;
            }
            .count {
              font-size: 16px;
            }
            .unit {
              padding-bottom: 1.5px;
            }
            .icon {
              padding-bottom: 1px;
            }
          }
          .register-count-box:last-child {
            margin-top: 18px;
          }
        }
        .register-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f5f7fa;
          height: 32px;
          padding-left: 10px;
          padding-right: 10px;
          margin-top: 8px;
          margin-bottom: 0;
          .wait-box {
            display: flex;
          }
          .item-title {
            color: #71747a;
            font-size: 14px;
          }
          .count {
            font-size: 16px;
          }
          .unit {
            padding-bottom: 1.5px;
          }
          .icon {
            padding-bottom: 1px;
          }
          .icon-box {
            margin-left: 4px;
            width: 25px;
            height: 14px;
            .icon-tip {
              width: 14px;
              height: 14px;
            }
          }
          
        }
        .register-item:last-child {
          margin-bottom: 16px;
        }
      }
    }
    .notice-box {
      height: 48px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 12px;

      .left-block {
        width: 4px;
        height: 48px;
        background: rgba(54, 179, 116, 1);
        margin-right: 12px;
      }
      .center-text {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        flex: 1;

        .greencolor {
          color: #36b374;
          margin: 0 4px;
        }
      }
      .right-box {
        display: flex;
        align-items: center;
        margin-right: 16px;

        .texts {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    .notice-box1 {
      width: 350px;
      display: flex;
      align-items: center;
      height: 30px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      box-sizing: border-box;
      padding-left: 16px;
      margin-bottom: 26px;
      overflow: hidden;
      position: relative;

      .left-text {
        width: 40px;
        font-size: 12px;
        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 700 !important;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
        margin-right: 15px;
        display: flex;
        align-items: center;
      }
      .vline {
        transform: none !important;
        background: none !important;
        top: 0 !important;
        bottom: 0 !important;
        left: 56px !important;
        .borders-1px:after {
          position: absolute;
          content: "";
          top: -50%;
          bottom: -50%;
          left: -50%;
          right: -50%;
          -webkit-transform: scale(0.5);
          transform: scale(0.5);
          border-right: 1px solid #eeeeee;
        }
      }
      .swiper-box {
        width: 285px;
      }
    }
    .area-box {
      margin-top: 26px;
      .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 32px;
        box-sizing: border-box;
        padding-bottom: 12px;

        .areachoose-box {
          display: flex;
          align-items: center;

          .area-text {
            font-size: 20px;
            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-right: 4px;
          }
          .down-icon {
            width: 6px;
          }
        }
        .search-icon {
          width: 15px;
          // height: 14px;
        }
      }
      .content-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .items-box {
          height: 126px;
          width: 49.5%;
          display: inline-block;
          box-sizing: border-box;
          padding-top: 24px;
          padding-bottom: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;
          position: relative;

          .name-box {
            display: flex;
            align-items: center;

            .names {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              margin-right: 4px;
              line-height: 12px;
            }
            .right-icon {
              width: 12px;
              height: 12px;
              // margin-top: -2px;
            }
          }
          .numbers {
            height: 48px;
            font-size: 32px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            line-height: 48px;
            font-family: PingFangSC-Regular, PingFang SC;
            -webkit-font-smoothing: antialiased;
          }
          .compare-box {
            height: 17px;
            display: flex;
            align-items: center;

            .compare-text {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
              margin-right: 4px;
            }
            .price-box {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              height: 17px;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              .equal {
                color: rgba(34, 131, 230, 1);
                line-height: 17px;
              }

              .add,
              .addprice {
                color: rgba(54, 179, 116, 1);
                line-height: 17px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .decrease,
              .decreprice {
                color: rgba(255, 77, 77, 1);
                line-height: 17px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .jiantou {
                width: 7px;
                height: 14px;
                margin-left: 2px;
                margin-top: -1px;
              }
              .jiantou-transform {
                transform: rotateX(180deg);
              }
            }
          }
        }
        .one-item {
          width: 100%;
        }
      }
    }
    .cityranking-box {
      box-sizing: border-box;
      padding-top: 14px;

      .title-box {
        font-size: 20px;
        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
        height: 44px;
        line-height: 44px;
        display: flex;
        align-items: center;
      }
      .content-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        overflow: hidden;
        position: relative;
        .data-card-tab {
          margin-top: 16px !important;
          margin-bottom: 18px !important;
          margin-left: 16px;
        }
        .unit-box {
          position: absolute;
          top: 56px;
          left: 16px;
          font-size: 10px;
          color: rgba(153, 153, 153, 1);
          font-weight: 400;
        }
        .city-contain-box {
          max-height: 200px;
          transition: max-height 0.3s ease-in;
        }

        .lookmore-box {
          box-sizing: border-box;
          // padding: 16px 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .txts {
            display: inline-block;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(155, 155, 155, 1);
            margin-right: 3px;
            line-height: 50px;
            // background: pink;
          }
          .img-more {
            display: inline-block;
            width: 7px;
            margin-bottom: 1px;
            // background: yellow;
          }

          .img-more-translate {
            transform: rotate(180deg);
            transform-origin: center center;
            margin-bottom: 3px;
          }
        }
        .monthnow {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 20px;
          text-align: center;
          margin-top: -60px;
          margin-bottom: 16px;
        }
      }
    }
  }
}

.vline {
  transform: none !important;
  background: none !important;
  top: 125px !important;
  bottom: 0 !important;
  height: 127px !important;
  .borders-1px:after {
    position: absolute;
    content: "";
    top: -75%;
    bottom: -75%;
    left: -75%;
    right: -75%;
    -webkit-transform: scale(0.4);
    transform: scale(0.4);
    border-right: 1px solid #eeeeee;
  }
}

.one-item-line {
  width: 100%;
  position: absolute !important;
  bottom: 0 !important;
  left: 0;
  right: 0;
  height: 1px;
}
.tips-text {
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
.role-pop-box {
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  .title {
    max-width: 200px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
  }
  .close-btn {
    margin-top: 10px;
    align-self:flex-end;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 26px;
    color: #4ce699;
    border-radius: 4px;
    border: 0.5px solid #4ce699;
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
